import {AuditedSerializable, ISerializable} from './base';

export class Group extends AuditedSerializable<Group> {

    userId: string | undefined;
    groupName: string | undefined;
    

    override deserialize(input: any): Group {
        super.deserialize(input);
        this.userId = input.userId;
        this.groupName = input.groupName;
        return this;
    }
}


